import { createWebRegistration } from '@reflex/plugin-api/create-web-registration';
import { EMAIL_AUTH_PROVIDER } from '../constants';
import { EmailAuthForm } from './EmailAuthForm';

/**
 * Web contribution for the email/password provider. Mirrors how OAuth plugins
 * contribute their icon — here the plugin contributes a self-contained sign-in
 * / registration form through the same `authProviders` slot, keyed by the
 * provider name the host knows (`email`). The host resolves it via
 * `getAuthProviderForm('email')` and renders it on the login, signup, and
 * first-run setup screens.
 */
export default createWebRegistration({
  authProviders: {
    [EMAIL_AUTH_PROVIDER]: {
      form: EmailAuthForm,
    },
  },
});
